import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import PageTitle from '../../../components/Editor/PageTitle';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			slider: { page },
			thumbnails,
			isThumbnailsDisplayed,
		},
	} = state;

	const { label, type, fileType, proposal } = thumbnails[page - 1];

	return {
		label,
		type,
		fileFormat: fileType,
		isProposal: proposal,
		isWide: !isThumbnailsDisplayed,
	};
};

export default connect(mapStateToProps)(PageTitle);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/PageTitle/index.tsx